// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Override NgbModal shell ───────────────────────────── */
:host ::ng-deep .modal-content {
  background: #07161a;
  border: 1px solid rgba(45, 212, 191, 0.18);
  border-radius: 16px;
  overflow: hidden;
  box-shadow:
    0 0 0 1px rgba(45, 212, 191, 0.06),
    0 32px 80px rgba(0, 0, 0, 0.7),
    0 0 60px rgba(45, 212, 191, 0.05) inset;
}

/* ── Panel ─────────────────────────────────────────────── */
.rum-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 3rem 2.5rem 2.5rem;
  background:
    radial-gradient(ellipse 70% 50% at 50% 0%, rgba(0, 84, 84, 0.35) 0%, transparent 70%),
    radial-gradient(ellipse 50% 40% at 80% 90%, rgba(45, 212, 191, 0.06) 0%, transparent 60%),
    #07161a;
  animation: rum-enter 0.45s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes rum-enter {
  from {
    opacity: 0;
    transform: translateY(14px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ── Icon ──────────────────────────────────────────────── */
.rum-icon-wrap {
  position: relative;
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.75rem;
}

.rum-ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(45, 212, 191, 0.35);
}

.rum-ring--1 {
  width: 72px;
  height: 72px;
  animation: rum-pulse 2.4s ease-out infinite;
}

.rum-ring--2 {
  width: 72px;
  height: 72px;
  animation: rum-pulse 2.4s ease-out 0.8s infinite;
}

@keyframes rum-pulse {
  0%   { transform: scale(1);   opacity: 0.6; }
  100% { transform: scale(2.2); opacity: 0; }
}

.rum-icon {
  font-size: 1.75rem;
  color: #2dd4bf;
  filter: drop-shadow(0 0 12px rgba(45, 212, 191, 0.5));
  animation: rum-spin-in 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.15s both;
}

@keyframes rum-spin-in {
  from { opacity: 0; transform: rotate(-90deg) scale(0.7); }
  to   { opacity: 1; transform: rotate(0deg) scale(1); }
}

/* ── Badge ─────────────────────────────────────────────── */
.rum-badge {
  font-family: 'DM Sans', sans-serif;
  font-size: 0.65rem;
  font-weight: 500;
  letter-spacing: 0.18em;
  color: #2dd4bf;
  text-transform: uppercase;
  background: rgba(45, 212, 191, 0.1);
  border: 1px solid rgba(45, 212, 191, 0.2);
  border-radius: 100px;
  padding: 0.25rem 0.85rem;
  margin-bottom: 1rem;
  animation: rum-fade-up 0.4s ease 0.2s both;
}

/* ── Title ─────────────────────────────────────────────── */
.rum-title {
  font-family: 'Syne', sans-serif;
  font-size: 2.15rem;
  font-weight: 800;
  line-height: 1.1;
  color: #f0fafa;
  margin: 0 0 1rem;
  letter-spacing: -0.02em;
  animation: rum-fade-up 0.4s ease 0.28s both;
}

/* ── Body text ─────────────────────────────────────────── */
.rum-body {
  font-family: 'DM Sans', sans-serif;
  font-size: 0.92rem;
  font-weight: 400;
  line-height: 1.6;
  color: rgba(180, 220, 220, 0.7);
  max-width: 340px;
  margin: 0 0 2rem;
  animation: rum-fade-up 0.4s ease 0.34s both;
}

/* ── Button ────────────────────────────────────────────── */
.rum-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  max-width: 320px;
  padding: 0.9rem 1.75rem;
  background: #2dd4bf;
  color: #041012;
  border: none;
  border-radius: 10px;
  font-family: 'Syne', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  animation: rum-fade-up 0.4s ease 0.42s both;
}

.rum-btn::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.25) 50%, transparent 60%);
  transform: translateX(-100%);
  transition: transform 0.55s ease;
}

.rum-btn:hover::before {
  transform: translateX(100%);
}

.rum-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(45, 212, 191, 0.35);
}

.rum-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(45, 212, 191, 0.2);
}

.rum-btn-arrow {
  font-size: 1.1rem;
  transition: transform 0.15s ease;
}

.rum-btn:hover .rum-btn-arrow {
  transform: translateX(3px);
}

/* ── Shared fade-up entrance ───────────────────────────── */
@keyframes rum-fade-up {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/modal-reload-app/modal-reload-app.component.css"],"names":[],"mappings":"AAEA,6DAA6D;AAC7D;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB;;;2CAGyC;AAC3C;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B;;;WAGS;EACT,8DAA8D;AAChE;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,OAAO,mBAAmB,IAAI,YAAY,EAAE;EAC5C,OAAO,qBAAqB,EAAE,UAAU,EAAE;AAC5C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qDAAqD;EACrD,qEAAqE;AACvE;;AAEA;EACE,OAAO,UAAU,EAAE,oCAAoC,EAAE;EACzD,OAAO,UAAU,EAAE,gCAAgC,EAAE;AACvD;;AAEA,6DAA6D;AAC7D;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,mCAAmC;EACnC,yCAAyC;EACzC,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,6DAA6D;AAC7D;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA,6DAA6D;AAC7D;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uDAAuD;EACvD,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iGAAiG;EACjG,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6DAA6D;AAC7D;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@400;500&display=swap');\n\n/* ── Override NgbModal shell ───────────────────────────── */\n:host ::ng-deep .modal-content {\n  background: #07161a;\n  border: 1px solid rgba(45, 212, 191, 0.18);\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow:\n    0 0 0 1px rgba(45, 212, 191, 0.06),\n    0 32px 80px rgba(0, 0, 0, 0.7),\n    0 0 60px rgba(45, 212, 191, 0.05) inset;\n}\n\n/* ── Panel ─────────────────────────────────────────────── */\n.rum-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 3rem 2.5rem 2.5rem;\n  background:\n    radial-gradient(ellipse 70% 50% at 50% 0%, rgba(0, 84, 84, 0.35) 0%, transparent 70%),\n    radial-gradient(ellipse 50% 40% at 80% 90%, rgba(45, 212, 191, 0.06) 0%, transparent 60%),\n    #07161a;\n  animation: rum-enter 0.45s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes rum-enter {\n  from {\n    opacity: 0;\n    transform: translateY(14px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ── Icon ──────────────────────────────────────────────── */\n.rum-icon-wrap {\n  position: relative;\n  width: 72px;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.75rem;\n}\n\n.rum-ring {\n  position: absolute;\n  border-radius: 50%;\n  border: 1px solid rgba(45, 212, 191, 0.35);\n}\n\n.rum-ring--1 {\n  width: 72px;\n  height: 72px;\n  animation: rum-pulse 2.4s ease-out infinite;\n}\n\n.rum-ring--2 {\n  width: 72px;\n  height: 72px;\n  animation: rum-pulse 2.4s ease-out 0.8s infinite;\n}\n\n@keyframes rum-pulse {\n  0%   { transform: scale(1);   opacity: 0.6; }\n  100% { transform: scale(2.2); opacity: 0; }\n}\n\n.rum-icon {\n  font-size: 1.75rem;\n  color: #2dd4bf;\n  filter: drop-shadow(0 0 12px rgba(45, 212, 191, 0.5));\n  animation: rum-spin-in 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.15s both;\n}\n\n@keyframes rum-spin-in {\n  from { opacity: 0; transform: rotate(-90deg) scale(0.7); }\n  to   { opacity: 1; transform: rotate(0deg) scale(1); }\n}\n\n/* ── Badge ─────────────────────────────────────────────── */\n.rum-badge {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 0.65rem;\n  font-weight: 500;\n  letter-spacing: 0.18em;\n  color: #2dd4bf;\n  text-transform: uppercase;\n  background: rgba(45, 212, 191, 0.1);\n  border: 1px solid rgba(45, 212, 191, 0.2);\n  border-radius: 100px;\n  padding: 0.25rem 0.85rem;\n  margin-bottom: 1rem;\n  animation: rum-fade-up 0.4s ease 0.2s both;\n}\n\n/* ── Title ─────────────────────────────────────────────── */\n.rum-title {\n  font-family: 'Syne', sans-serif;\n  font-size: 2.15rem;\n  font-weight: 800;\n  line-height: 1.1;\n  color: #f0fafa;\n  margin: 0 0 1rem;\n  letter-spacing: -0.02em;\n  animation: rum-fade-up 0.4s ease 0.28s both;\n}\n\n/* ── Body text ─────────────────────────────────────────── */\n.rum-body {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 0.92rem;\n  font-weight: 400;\n  line-height: 1.6;\n  color: rgba(180, 220, 220, 0.7);\n  max-width: 340px;\n  margin: 0 0 2rem;\n  animation: rum-fade-up 0.4s ease 0.34s both;\n}\n\n/* ── Button ────────────────────────────────────────────── */\n.rum-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  width: 100%;\n  max-width: 320px;\n  padding: 0.9rem 1.75rem;\n  background: #2dd4bf;\n  color: #041012;\n  border: none;\n  border-radius: 10px;\n  font-family: 'Syne', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n  animation: rum-fade-up 0.4s ease 0.42s both;\n}\n\n.rum-btn::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.25) 50%, transparent 60%);\n  transform: translateX(-100%);\n  transition: transform 0.55s ease;\n}\n\n.rum-btn:hover::before {\n  transform: translateX(100%);\n}\n\n.rum-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 28px rgba(45, 212, 191, 0.35);\n}\n\n.rum-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 10px rgba(45, 212, 191, 0.2);\n}\n\n.rum-btn-arrow {\n  font-size: 1.1rem;\n  transition: transform 0.15s ease;\n}\n\n.rum-btn:hover .rum-btn-arrow {\n  transform: translateX(3px);\n}\n\n/* ── Shared fade-up entrance ───────────────────────────── */\n@keyframes rum-fade-up {\n  from { opacity: 0; transform: translateY(10px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
